import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=27141fe6&scoped=true&"
import script from "./StatusChip.vue?vue&type=script&lang=js&"
export * from "./StatusChip.vue?vue&type=script&lang=js&"
import style0 from "./StatusChip.vue?vue&type=style&index=0&id=27141fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27141fe6",
  null
  
)

export default component.exports